import { PlanningOverview } from '@interhyp/module-case-assignment';
import { BaseLayout, Footer } from '@interhyp/platform-layout';
import React from 'react';

function CaseAssignmentPlanningModule() {
  return (
    <>
      <BaseLayout>
        <PlanningOverview />
      </BaseLayout>
      <Footer />
    </>
  );
}
export { CaseAssignmentPlanningModule };
